class FFUpdateSubscription {
	DOM: {
		form: HTMLFormElement;
		unsubscribeButton: HTMLButtonElement;
		submitButton: HTMLButtonElement;
		spinner: HTMLDivElement;
		allInputs: NodeListOf<HTMLInputElement>;
	};
	state = {
		status: 'pending',
		valid: false,
	};

	constructor() {
		const form = document.querySelector('.js-subscriptionUpdateForm');
		if (!form) return;
		this.DOM = {
			form: form as HTMLFormElement,
			unsubscribeButton: form.querySelector('.js-unsubscribeButton') as HTMLButtonElement,
			submitButton: form.querySelector('.js-submitButton') as HTMLButtonElement,
			spinner: form.querySelector('.js-spinner') as HTMLDivElement,
			allInputs: form.querySelectorAll('input, select'),
		};
		this.events();
		this.render();
	}

	events() {
		this.DOM.form.addEventListener('submit', this.formSubmit.bind(this));
		this.DOM.unsubscribeButton.addEventListener('click', this.unsubscribe.bind(this));
		for (let i = 0; i < this.DOM.allInputs.length; i++) {
			this.DOM.allInputs[i].addEventListener('input', this.globalInput.bind(this));
		}
	}

	unsubscribe() {
		if (this.state.status !== 'pending') return;
		this.state.status = 'working';
		this.render();
		const formData = new FormData(this.DOM.form);
		formData.append('action', 'update_subscription');
		formData.append('deleteSubscriber', 'true');
		this.requestUpdate(formData);
	}

	formSubmit(e: SubmitEvent) {
		e.preventDefault();
		if (!this.state.valid || this.state.status !== 'pending') return;
		this.state.status = 'working';
		this.render();
		const formData = new FormData(this.DOM.form);
		formData.append('action', 'update_subscription');
		const tags = formData.getAll('tag');
		formData.append('tag', tags.join(','));
		this.requestUpdate(formData);
	}

	requestUpdate(data: FormData) {
		if (typeof grecaptcha === 'undefined') {
			this.showErrorMessage(
				'Unable to verify your submission. Please disable ad blockers and try again.'
			);
			this.state.status = 'error';
			this.render();
			return;
		}

		grecaptcha.ready(() => {
			grecaptcha
				.execute(RECAPTCHA_SITE_KEY, { action: 'submit' })
				.then((token) => {
					data.append('g-recaptcha-response', token);
					return fetch(ajaxurl, {
						method: 'POST',
						body: data,
					}).then(this.formResponse.bind(this));
				})
				.catch((error: unknown) => {
					console.log(error);
					this.showErrorMessage('Unable to verify your submission. Please try again.');
					this.state.status = 'error';
					this.render();
				});
		});
	}

	async formResponse(res: Response) {
		window.scrollTo({ top: window.scrollY + 300, behavior: 'smooth' });
		const data = await res.json();
		if (res.status === 200) {
			this.showSuccessMessage(data.message);
			this.state.status = 'success';
		} else {
			this.showErrorMessage(`Request could not be processed.`);
			this.state.status = 'error';
		}
		this.render();
	}

	globalInput() {
		//Once a change is made, the form is valid
		this.state.valid = true;
		this.render();
	}

	render() {
		if (this.state.valid && this.state.status === 'pending') {
			this.DOM.submitButton.disabled = false;
		} else {
			this.DOM.submitButton.disabled = true;
		}
		if (this.state.status !== 'pending') {
			this.DOM.unsubscribeButton.disabled = true;
		}
		if (this.state.status === 'working') {
			this.DOM.spinner.classList.remove('js-hide');
		} else {
			this.DOM.spinner.classList.add('js-hide');
		}
	}

	showSuccessMessage(message: string) {
		const section = document.createElement('div');
		section.classList.add('section', 'messageSection', 'success');
		const html = `
<div class="sectionHeader">
  <h2 class="sectionHl">Success!</p>
</div>
<div class="sectionBody">
  <div class="formRow">
    <div class="formCol">
      <p>${message}</p>
    </div>
  </div>
</div>
`;
		section.innerHTML = html;
		this.DOM.form.appendChild(section);
	}

	showErrorMessage(message: string) {
		const section = document.createElement('div');
		section.classList.add('section', 'messageSection', 'error');
		const html = `
<div class="sectionHeader">
  <h2 class="sectionHl">Error</p>
</div>
<div class="sectionBody">
  <div class="formRow">
    <div class="formCol">
      <p>Uh oh. There was an issue with the form submission:</p>
      ${message ? `<pre>${message}</pre>` : ''}
      <p><a href="mailto:support@freeflysystems.com">Email support</a> for help.</p>
    </div>
  </div>
</div>
`;
		section.innerHTML = html;
		this.DOM.form.appendChild(section);
	}
}
new FFUpdateSubscription();
